import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AddressBookLocation } from '@/views/screens/AddressBook';
import type { AxiosResponse } from 'axios';

export const getDefaultShipmentPickupLocationAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetDefaultShipmentAddressbook`,
    method: 'get',
  });
};

export type DefaultShipmentPickupLocationResponse = AddressBookLocation;

export const fetchDefaultShipmentPickupLocation = async (): Promise<DefaultShipmentPickupLocationResponse> => {
  const response: AxiosResponse<DefaultShipmentPickupLocationResponse> = await getDefaultShipmentPickupLocationAPI();
  return response.data;
};
